<template>
  <div class="centerx">
    <vs-button @click="popupActivo=true" class="btn btn--green">Nuova nota</vs-button>
    <vs-popup class="holamundo" :active.sync="popupActivo">
      <!-- Questo è il codice da inserire nella vista della route -->
      <div class="row">
        <div class="col-lg-12 col-md-12 col-12">
          <form action="">
            <div class="form-group">
              <textarea placeholder="Scrivi qui la tua nota..." name="" id=""></textarea>
            </div>
            <div class="form-buttons">
              <button class="btn">Chiudi</button>
              <button type="submit" class="btn btn--green">Salva</button>
            </div>
          </form>
        </div>
      </div>
      <!-- Qua finisce il codice da inserire nella vista della route -->
    </vs-popup>
  </div>
</template>

<script>
export default {
  data(){
    return {
      popupActivo:false,
    }
  }
}
</script>
